import { createRouter, createWebHashHistory } from 'vue-router';

import LoginPage from '@/components/main/LoginPage.vue';
import MainEstabelecimento from '@/components/main/MainEstabelecimento.vue';
import MainGestor from '@/components/main/MainGestor.vue';
import MainInspetor from '@/components/main/MainInspetor.vue';
import MainPage from '@/views/main/MainPage.vue';
import MainSupervisor from '@/components/main/MainSupervisor.vue';
import DriveCimAmrecPublicPage from '@/views/utils/drive/DriveCimAmrecPublicPage.vue';

const routes = [
    { path: '/', name: 'LoginPage', component: LoginPage },
    { path: '/login', name: 'LoginPageLogin', component: LoginPage },
    { path: '/main-estabelecimento', name: 'MainEstabelecimento', component: MainEstabelecimento },
    { path: '/main-gestor', name: 'MainGestor', component: MainGestor },
    { path: '/main-inspetor', name: 'MainInspetor', component: MainInspetor },
    { path: '/main-page', name: 'MainPage', component: MainPage },
    { path: '/main-supervisor', name: 'MainSupervisor', component: MainSupervisor },
    { path: '/cim-amrec', name: 'DriveCimAmrecPublicPage', component: DriveCimAmrecPublicPage },
];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router;